import { useAppSelector } from "../store/hooks";

/**
 * True if the current user has been added to at least 1 partner, false if none.
 * Returns undefined while user hasn't been loaded.
 */
export const useHasPartner = () => useAppSelector(state => {
    if (state.user.email === null) return undefined; // user not loaded yet
    if (state.user.isAdmin) return true; // admins can access all partners
    return Object.keys(state.user.partnerPermissions ?? {}).length > 0;
});


/**
 * Custom hook to get user information with fallback for displayName
 * Handles cases where self-registered users might not have a displayName set
 */
export const useUserName = () => {
    const userEmail = useAppSelector(state => state.user.email);
    const userName = useAppSelector(state => state.user.name);

    // Create fallback displayName for self-registered users
        if (userName && userName.trim() !== '') {
            return userName;
        }
        
        if (userEmail) {
            // Extract username from email (part before @)
            const emailUsername = userEmail.split('@')[0];
            return emailUsername || 'Unknown User Name';
        }
        
        return 'Unknown User Name';
    };